(() => {
  const init = () => {
    document.querySelectorAll('.vinyl-academy__video-button').forEach((button) => {
      if (button.dataset.ready === 'true') return;
      button.dataset.ready = 'true';
      button.addEventListener('click', () => {
        const id = button.dataset.videoId || '';
        if (!/^[A-Za-z0-9_-]{11}$/.test(id)) return;
        const frame = document.createElement('iframe');
        frame.className = 'vinyl-academy__iframe';
        frame.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
        frame.title = button.dataset.videoTitle || 'Color PPF lesson';
        frame.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; web-share';
        frame.setAttribute('allowfullscreen', '');
        button.replaceWith(frame);
      }, { once: true });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
